import type { ReactNode } from 'react';

import { WidgetHeader, WidgetSubHeaderText } from './';

interface Props {
  title: string;
  subTitle?: ReactNode | string;
  headerMarginBottom?: number;
  marginBottom?: number;
}

export const WidgetHeaderWithSubText = ({
  title,
  subTitle,
  marginBottom,
}: Props) => (
  <>
    <WidgetHeader $marginBottom={!!subTitle ? 8 : 24}>{title}</WidgetHeader>
    {subTitle && (
      <WidgetSubHeaderText $marginBottom={marginBottom}>
        {subTitle}
      </WidgetSubHeaderText>
    )}
  </>
);
